import '../sass/style.scss'

import {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip
} from 'bootstrap'

import * as bootstrap from 'bootstrap'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// SVG-only build — all our animations use renderer:'svg', so this is ~half the size
// of the full lottie-web (which also bundles the canvas + html renderers).
import lottie from 'lottie-web/build/player/lottie_light'
window.bootstrap = bootstrap
// gsap + lottie are bundled here now (previously separately-enqueued global scripts).
// As external/CDN scripts they raced with — or were outright blocked by — the deferred
// module and the strict-dynamic CSP on stage ("gsap is not defined" / lottie "blocked:csp").
// Expose them on window so inline template scripts keep working: the carousels and the
// footer lottie init run in DOMContentLoaded (after this module), and index.js drives
// lottie play/stop from scroll handlers.
window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.lottie = lottie
gsap.registerPlugin(ScrollTrigger)

// Lazily load the carousels (shared module) only on pages that render them.
const testimonialsCarousels = document.querySelectorAll<HTMLElement>(
  '.testimonials-carousel-container'
)
if (testimonialsCarousels.length) {
  import('./modules/carousel').then(({ default: init }) => {
    init(testimonialsCarousels, '.testimonials-carousel-slide')
  })
}

const mediaCarousels = document.querySelectorAll<HTMLElement>('.media-carousel-container')
if (mediaCarousels.length) {
  import('./modules/carousel').then(({ default: init }) => {
    init(mediaCarousels, '.media-carousel-slide')
  })
}

// Testimonials gallery slider — lazy-loaded.
if (document.querySelector('.testimonials-gallery')) {
  import('./modules/testimonials-gallery').then(({ default: init }) => {
    init()
  })
}

// Embla sliders — lazy-loaded (keeps embla-carousel out of the main bundle).
const jsSliders = document.querySelectorAll<HTMLElement>('.js-slider')
if (jsSliders.length) {
  import('./modules/js-slider').then(({ default: init }) => {
    init(jsSliders)
  })
}

// Scroll-driven product section — lazy-loaded.
if (document.querySelector('[data-scroll-product-container]')) {
  import('./modules/scroll-product').then(({ default: init }) => {
    init()
  })
}

// Scroll-driven display section — lazy-loaded.
if (document.querySelector('[data-scroll-display-container]')) {
  import('./modules/scroll-display').then(({ default: init }) => {
    init()
  })
}

// Scroll-reveal (fade-in / intro) animations — lazy-loaded.
if (document.querySelector('[data-fade-in-container], [data-intro-parent]')) {
  import('./modules/reveal').then(({ default: init }) => {
    init()
  })
}

// Hero videos that carry a mobile + desktop cut — lazy-loaded. Re-picks the
// source when the viewport crosses the breakpoint, which <source media> alone
// does not do on a <video>.
const responsiveVideos = document.querySelectorAll<HTMLVideoElement>('[data-responsive-video]')
if (responsiveVideos.length) {
  import('./modules/responsive-video').then(({ default: init }) => {
    init(responsiveVideos)
  })
}

// AJAX post-type listing filter + pagination — lazy-loaded.
if (document.querySelector('#postLinkCards')) {
  import('./modules/post-filter').then(({ default: init }) => {
    init()
  })
}

// Bind to the window
window.cf = {
  getOffsetTop(elem) {
    var offsetTop = 0
    do {
      if (!isNaN(elem.offsetTop)) {
        offsetTop += elem.offsetTop
      }
    } while ((elem = elem.offsetParent))
    return offsetTop
  },
  extend(a, b) {
    for (var key in b) if (b.hasOwnProperty(key)) a[key] = b[key]
    return a
  },
  parallaxAnimate(eleSelector, opts) {
    var defaults = {
      speed: 1,
      position: 0.85,
      setCallback: function () {},
      refreshCallback: function () {}
    }
    var options = cf.extend(defaults, opts)
    var elems = document.querySelectorAll(eleSelector)

    elems.forEach(function (elem, index) {
      if (!elem) {
        return
      }
      options.setCallback(elem, index)
      document.addEventListener(
        'scroll',
        function (e) {
          scrolledContent()
        },
        false
      )
      scrolledContent()

      function scrolledContent() {
        let winHeight = window.innerHeight
        let eleHeight = elem.offsetHeight
        let scrollerPosition = window.pageYOffset || document.documentElement.scrollTop
        let eleTopPosition = cf.getOffsetTop(elem)
        let topPosition
        if (
          eleTopPosition + eleHeight < scrollerPosition ||
          eleTopPosition > scrollerPosition + winHeight * options.position
        ) {
          return
        }
        topPosition = window.scrollY - eleTopPosition + winHeight * options.position * options.speed
        options.refreshCallback(elem, scrollerPosition, topPosition, index)
      }
    })
  },
  triggerAnimate(eleSelector, opts) {
    var defaults = {
      triggerPosition: 0.85,
      setCallback: function () {},
      refreshCallback: function () {}
    }
    var options = cf.extend(defaults, opts)

    var winHeight = window.innerHeight
    var elems = document.querySelectorAll(eleSelector)

    elems.forEach(function (elem, index) {
      if (!elem) {
        return
      }
      options.setCallback(elem, index)
      let eleStatus = true
      document.addEventListener('scroll', function (e) {
        scrolledContent()
      })
      scrolledContent()
      function scrolledContent() {
        let ScrollerPosition = window.scrollY
        let eleTopPosition = cf.getOffsetTop(elem)
        if (!eleStatus) {
          return
        }
        if (ScrollerPosition > eleTopPosition - winHeight * options.triggerPosition) {
          options.refreshCallback(elem, index)
          eleStatus = false
        }
      }
    })
  },
  fixedHeader(eleSelector, opts) {
    var defaults = {}
    var options = cf.extend(defaults, opts)
    var header = document.querySelector(eleSelector)
    if (!header) {
      return
    }
    let headerHt = header.clientHeight
    let lastScrollTop = 0

    let button = header.querySelector('[data-bs-toggle="collapse"]')
    let myCollapse

    if (button) {
      let buttonid = button.getAttribute('data-bs-target')
      myCollapse = header.querySelector(buttonid)
      myCollapse = bootstrap.Collapse.getOrCreateInstance(myCollapse, {
        toggle: false
      })
    }
    var navbar = header.querySelector('.navbar')
    function handleScroll() {
      var st = window.pageYOffset || document.documentElement.scrollTop
      var scrollDisplayContainer = document.querySelector('[data-scroll-display-container]')

      // if (st > 0) navbar.classList.remove('front-page-header')
      if (st > 200) {
        // navbar.classList.add('bg-white')
        if (window.innerWidth > 991) {
          if (navbar.classList.contains('navbar-dark')) {
            navbar.querySelector('.btn').classList.remove('btn-primary')
            navbar.querySelector('.btn').classList.add('btn-dark')
          }
        }
      } else {
        // navbar.classList.remove('bg-white')
        if (navbar.classList.contains('navbar-dark')) {
          navbar.querySelector('.btn').classList.add('btn-primary')
          navbar.querySelector('.btn').classList.remove('btn-dark')
        }
      }
      if (st === 0 && document.body.classList.contains('home'))
        navbar.classList.add('front-page-header')

      if (window.innerWidth < 992) {
        navbar.querySelector('.btn').classList.add('btn-primary')
        navbar.querySelector('.btn').classList.remove('btn-dark')
      }

      if (st > lastScrollTop) {
        header.style.top = '-' + headerHt + 'px'
        if (button) {
          myCollapse.hide()
        }
        hideNavbar(navButton, navMenu, navbar, true)
      } else {
        let windowWid = screen.width
        if (
          scrollDisplayContainer &&
          scrollDisplayContainer.classList.contains('active') &&
          windowWid > 767
        ) {
          header.style.top = '-' + headerHt + 'px'
          if (button) {
            myCollapse.hide()
          }
          hideNavbar(navButton, navMenu, navbar, true)
        } else {
          // upscroll code
          header.style.top = '0px'
          if (button) {
            myCollapse.hide()
          }
          hideNavbar(navButton, navMenu, navbar, false)
        }
      }

      lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
    }
    document.addEventListener('scroll', handleScroll, false)

    if (window.innerWidth < 992) {
      navbar.querySelector('.btn').classList.add('btn-primary')
      navbar.querySelector('.btn').classList.remove('btn-dark')
    }
  },
  mobileCheck() {
    let check = false
    ;(function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true
    })(navigator.userAgent || navigator.vendor || window.opera)
    return check
  }
}

window.counter = {
  numberCountSet(elem) {
    let elements = elem.querySelectorAll('[data-counter]')
    elements.forEach(function (element, index) {
      let innerText = element.getAttribute('data-counter')
      let str = ''
      for (let i = 0; i < innerText.length; i++) {
        str += '0'
      }
      element.innerHTML = str
      element.style.display = 'inline-block'
      setTimeout(function () {
        element.style.width = element.clientWidth + 1 + 'px'
      }, 100)
    })
  },
  numberCount(elem) {
    let elements = elem.querySelectorAll('[data-counter]')
    setTimeout(function () {
      elements.forEach(function (element, index) {
        let x = 0
        let count = parseInt(element.getAttribute('data-counter'))
        const myInterval = setInterval(myCounter, 20)
        function myCounter() {
          x = x + 40
          element.innerHTML = x
          if (x >= count) {
            clearInterval(myInterval)
            element.innerHTML = count
            element.removeAttribute('style')
          }
        }
      })
    }, 100)
  }
}

document.querySelectorAll('a[href^="#"]').forEach(function (anchor, index) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    })
  })
})

var sidebarnav = document.querySelectorAll('.sideNav .nav-link')
if (sidebarnav) {
  let elems = []
  sidebarnav.forEach(function (item, index) {
    item.addEventListener('click', function (event) {
      event.preventDefault()
      this.offsetParent.querySelector('.active').classList.remove('active')
      item.classList.add('active')
      let eleID = item.getAttribute('href')

      if (eleID != '#') {
        eleID = document.querySelector(eleID)
      }
      if (eleID && eleID != '#') {
        let num
        if (screen.width > 768) {
          num = 110
        } else {
          num = 70
        }
        window.scrollTo({
          top: window.cf.getOffsetTop(eleID) - num,
          left: 0,
          behavior: 'smooth'
        })
      }
    })

    let idelems = item.getAttribute('href')
    if (idelems != '#') {
      idelems = document.querySelector(idelems)
    }
    if (idelems && idelems != '#') {
      elems.push({
        index: index,
        item: item,
        offsetTop: window.cf.getOffsetTop(idelems) - 130,
        nextOffsetTop: idelems.nextElementSibling
          ? window.cf.getOffsetTop(idelems.nextElementSibling) - 130
          : '999999'
      })
    }
    function moveScroll() {
      let scrollerPosition = window.pageYOffset || document.documentElement.scrollTop
      if (elems[index] != undefined) {
        elems[index].item.classList.remove('active')
        if (
          scrollerPosition > elems[index].offsetTop &&
          scrollerPosition < elems[index].nextOffsetTop
        ) {
          elems[index].item.classList.add('active')
        } else if (scrollerPosition < elems[0].offsetTop) {
          elems[0].item.classList.add('active')
        }
      }
    }
    document.addEventListener('scroll', function (event) {
      moveScroll()
    })
    moveScroll()
  })
}

window.animate = {
  headingSet(elem) {
    gsap.set(elem.querySelectorAll('h3,p'), {
      x: 100,
      opacity: 0
    })
  },
  heading(elem) {
    gsap.to(elem.querySelectorAll('h3,p'), {
      x: 0,
      opacity: 1,
      duration: 1,
      stagger: 0.2
    })
  },
  slideupSet(elem) {
    gsap.set(elem.querySelectorAll('.card'), {
      y: 100,
      opacity: 0
    })
  },
  slideup(elem) {
    gsap.to(elem.querySelectorAll('.card'), {
      y: 0,
      opacity: 1,
      duration: 1,
      stagger: 0.2
    })
  },
  // scrollDisplayLineSet(elem) {
  //     gsap.set(elem.querySelectorAll('.heading-line svg #line-box'), {
  //         yPercent: 0,
  //     });
  // },
  // scrollDisplayLine(elem) {
  //     gsap.to(elem.querySelectorAll('.heading-line svg #line-box'), {
  //         yPercent: 100,
  //         duration: 1,
  //     });
  // },
  // scrollDisplayImgSet(elem) {
  //     gsap.set(elem.querySelectorAll('.scrollDisplay-img img'), {
  //         scale: 0,
  //         opacity:0,
  //         transformOrigin: "50% 50%",
  //     });

  // },
  scrollDisplayImg(elem) {
    // gsap.to(elem.querySelectorAll('.scrollDisplay-img img'), {
    //     scale: 1,
    //     opacity: 1,
    //     duration: 1,
    //     stagger: 0.20,
    //     transformOrigin: "50% 50%",
    // });

    let animateEle = elem.querySelector('.animate-lottie')
    if (animateEle) {
      let dataId = animateEle.getAttribute('data-id')
      lottie[dataId].stop()
      lottie[dataId].play()
    }
  },
  textMediaSet(elem) {
    gsap.set(elem.querySelectorAll('.textMedia-img img'), {
      scale: 0,
      opacity: 0,
      transformOrigin: '50% 50%'
    })
  },
  textMedia(elem) {
    gsap.to(elem.querySelectorAll('.textMedia-img img'), {
      scale: 1,
      opacity: 1,
      duration: 1,
      stagger: 0.2,
      transformOrigin: '50% 50%'
    })
    let animateEle = elem.querySelector('.animate-lottie')
    let dataId = animateEle.getAttribute('data-id')
    lottie[dataId].play()
  },
  illustrationDisplaySet(elem) {},
  illustrationDisplay(elem) {
    let animateEle = elem.querySelectorAll('.animate-lottie')
    animateEle.forEach(function (item, index) {
      let dataId = item.getAttribute('data-id')
      lottie[dataId].play()
    })
  },
  illustrationTitleSet(elem) {},
  illustrationTitle(elem) {
    let animateEle = elem.querySelector('.animate-lottie')
    let dataId = animateEle.getAttribute('data-id')
    lottie[dataId].play()
  }
}

// cf.triggerAnimate(".slideup", {
//     setCallback: animate.slideupSet,
//     refreshCallback: animate.slideup,
//     triggerPosition: 0.65,
// });
// cf.triggerAnimate(".heading", {
//     setCallback: animate.headingSet,
//     refreshCallback: animate.heading,
//     triggerPosition: 0.65,
// });
cf.triggerAnimate('.textMedia', {
  setCallback: animate.textMediaSet,
  refreshCallback: animate.textMedia,
  triggerPosition: 0.4
})
// cf.triggerAnimate(".scrollDisplay", {
//     setCallback: animate.scrollDisplayLineSet,
//     refreshCallback: animate.scrollDisplayLine,
//     triggerPosition: 0.40,
// });

// cf.triggerAnimate(".scrollDisplay", {
//     setCallback:animate.scrollDisplayImgSet,
//     refreshCallback:animate.scrollDisplayImg,
//     triggerPosition: 0.2,
// });

cf.triggerAnimate('.illustrationDisplay', {
  setCallback: animate.illustrationDisplaySet,
  refreshCallback: animate.illustrationDisplay,
  triggerPosition: 0.2
})
cf.triggerAnimate('.illustrationTitle', {
  setCallback: animate.illustrationTitleSet,
  refreshCallback: animate.illustrationTitle,
  triggerPosition: 0.2
})

var count = 0
var lastTop = 0
var timer = null
var triggerTabList = [].slice.call(document.querySelectorAll('#scroll-tab [data-bs-toggle="tab"]'))

triggerTabList.forEach(function (triggerEl, index) {
  var tabTrigger = new bootstrap.Tab(triggerEl)
  triggerEl.addEventListener('click', function (event) {
    event.preventDefault()
    count = index + 1
    tabTrigger.show()
  })
})

let pager = document.querySelector('.scrollDisplay-pager')
triggerTabList.forEach(function (item, index) {
  let span = document.createElement('span')
  if (index == 0) {
    span.classList.add('active')
  }
  pager.append(span)
})

var vButton = document.querySelector('.media-video--button')

if (vButton) {
  vButton.addEventListener('click', function () {
    var video = vButton.getAttribute('data-id')
    video = document.getElementById(video)
    if (video.paused) {
      video.play()
      vButton.classList.add('pause')
    } else {
      video.pause()
      vButton.classList.remove('pause')
    }
  })
}

//trigger Animatin on tab change

// triggerTabList.forEach(function (tabEl,index) {
//     tabEl.addEventListener('shown.bs.tab', function (event) {

//         cf.triggerAnimate(event.target.getAttribute("data-bs-target"), {
//             setCallback:animate.scrollDisplayImgSet,
//             refreshCallback:animate.scrollDisplayImg,
//             triggerPosition: 0.7,
//         });

//         let pager = document.querySelectorAll('.scrollDisplay-pager span');
//         if(pager[index].offsetParent != null){
//             pager[index].offsetParent.querySelector(".active").classList.remove("active");
//             pager[index].classList.add("active");
//         }
//     });
// });

window.pAnimate = {
  introSet(elem) {
    gsap.set(elem.querySelectorAll('.intro-line svg #box'), {
      y: 0
    })
  },
  intro(elem, scroller, topPosition) {
    let childs = elem.querySelectorAll('.col-12')
    let myvalue = 0
    let childvalue

    childs.forEach(function (child, index) {
      childvalue = child.offsetHeight / 2 + child.offsetTop
      if (topPosition < childvalue) {
        if (topPosition >= myvalue) {
          myvalue = childvalue
        }
      }
    })
    if (myvalue == 0) {
      myvalue = childvalue
    }
    gsap.to(elem.querySelectorAll('.intro-line svg #box'), {
      duration: 2,
      y: myvalue - 50
    })
  },
  // scrollDisplaySet(elem) {
  //     elem.style.height = elem.offsetHeight +1500+"px";
  //     let eleTopPadding = window.getComputedStyle(elem).getPropertyValue('padding-top');
  //     let elemContainer  = elem.querySelector(".scrollDisplay-container");
  //     elemContainer.style.top = eleTopPadding;
  // },
  // scrollDisplay(elem,scroller,topPosition) {
  //     if(timer !== null) {
  //         clearTimeout(timer);
  //     }

  //     timer = setTimeout(function() {
  //         // do something
  //         let eleHeight = elem.offsetHeight;
  //         let winHeight = window.innerHeight;
  //         let eleTopPosition = cf.getOffsetTop(elem);

  //         if (scroller > lastTop ){
  //             count++;
  //             if(count==triggerTabList.length){
  //                window.scroll(0,eleTopPosition+eleHeight-winHeight);
  //             }
  //             if(count>=triggerTabList.length){
  //                 count=triggerTabList.length
  //             }
  //             let triggerEl = document.querySelector('#scroll-tab [data-bs-target="#tab'+count+'"]');
  //             bootstrap.Tab.getOrCreateInstance(triggerEl).show(); // Select tab by name

  //         } else {
  //             if(scroller+winHeight < eleTopPosition+eleHeight){
  //                 count--;
  //                 if(count==1){
  //                     window.scroll(0,eleTopPosition);
  //                 }
  //                 if(count<=1){
  //                     count=1
  //                 }
  //                 let triggerEl = document.querySelector('#scroll-tab [data-bs-target="#tab'+count+'"]');
  //                 bootstrap.Tab.getOrCreateInstance(triggerEl).show(); // Select tab by name
  //             }
  //         }
  //         lastTop = scroller <= 0 ? 0 : scroller; // For Mobile or negative scrolling
  //     }, 150);
  // },

  sideNavFixedSet(elem) {
    gsap.set('.sidebar', {
      y: 0
    })
  },

  sideNavFixed(elem, scroller, topPosition) {
    if (screen.width < 768) {
      let sidebar = document.querySelector('.sideNav')
      let eleHeight = elem.offsetHeight
      let eleTopPosition = cf.getOffsetTop(elem)
      if (topPosition > 100 && eleHeight + eleTopPosition > scroller + 100) {
        console.log(scroller)
        sidebar.classList.add('fixed')
      } else {
        setTimeout(function () {
          sidebar.classList.remove('fixed')
        }, 100)
      }
    }
  }
}

cf.parallaxAnimate('.location', {
  setCallback: pAnimate.sideNavFixedSet,
  refreshCallback: pAnimate.sideNavFixed,
  position: 0
})

cf.parallaxAnimate('.intro', {
  setCallback: pAnimate.introSet,
  refreshCallback: pAnimate.intro,
  position: 0.5,
  speed: 1
})

let windowWid = screen.width
if (windowWid > 991) {
  // cf.parallaxAnimate(".scrollDisplay", {
  //     setCallback: pAnimate.scrollDisplaySet,
  //     refreshCallback: pAnimate.scrollDisplay,
  //     position: 0,
  //     speed: 1,
  // });
}

//trigger Animatin on tab change

/*var tabEls = document.querySelectorAll('#pills-tab button[data-bs-toggle="pill"]');
tabEls.forEach(function (tabEl) {
    tabEl.addEventListener('shown.bs.tab', function (event) {
        // cf.triggerAnimate(event.target.getAttribute("data-bs-target"), {
        //     refreshCallback:animate.tabingText,
        //     setCallback:animate.tabingTextSet,
        //     triggerPosition: 0.5,
        // });
    });
});*/

// open tab with #link

/*var hash = window.location.hash;
if(hash){
    var triggerEl = document.querySelector('#pills-tab button[data-bs-target="'+hash+'"]');
    if(triggerEl != null){
        bootstrap.Tab.getInstance(triggerEl).show(); // Select tab by name
    }
}*/

cf.triggerAnimate('.numbers', {
  setCallback: counter.numberCountSet,
  refreshCallback: counter.numberCount,
  triggerPosition: 0.9
})

//make header fixed on scroll;
cf.fixedHeader('header')

var navButton = document.querySelector('.navbar-toggler')
var navMenu = document.querySelector('.navbar-nav')
var navbar = document.querySelector('.navbar')

function hideNavbar(navButton, navMenu, navbar, white) {
  navButton.classList.remove('collapsed')
  navMenu.classList.remove('show')
  if (white) {
    navbar.classList.add('bg-white')
  }
}

navButton.addEventListener('click', function () {
  // Check if Cookiebot is available and if it is open, close it
  if (
    typeof Cookiebot !== 'undefined' &&
    Cookiebot !== null &&
    typeof Cookiebot.consent === 'object' &&
    typeof Cookiebot.consent.marketing === 'boolean'
  ) {
    if (navMenu.classList.contains('show')) {
      dataLayer.push({
        event: 'main_menu',
        event_info: [
          {
            user_interaction: 'hamburger_menu_close',
            navigation_selection: 'not_available'
          }
        ]
      })
    } else {
      dataLayer.push({
        event: 'main_menu',
        event_info: [
          {
            user_interaction: 'hamburger_menu_open',
            navigation_selection: 'not_available'
          }
        ]
      })
    }
  }
  navButton.classList.toggle('collapsed')
  navMenu.classList.toggle('show')

  let st = window.pageYOffset || document.documentElement.scrollTop
  if (st > 200) {
    navbar.classList.toggle('bg-white')
  } else {
    navbar.classList.remove('bg-white')
  }
})

// dropdown on hover

var dropdownElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'))
dropdownElementList.forEach(function (dropdownToggleEl) {
  var dropdown = new bootstrap.Dropdown(dropdownToggleEl)
  dropdownToggleEl.addEventListener('click', function (event) {
    window.location.href = dropdownToggleEl.getAttribute('href')
  })
  dropdownToggleEl.addEventListener('mouseenter', function () {
    dropdown.show()
  })
  // offsetParent is null whenever the toggle isn't rendered — on mobile the desktop
  // dropdowns are display:none. Dereferencing it threw at module top level, which
  // aborted the rest of this file (modal links, lazy-loaded forms, everything below).
  dropdownToggleEl.offsetParent?.addEventListener('mouseleave', function () {
    dropdown.hide()
  })
})

// tabs on hover

var isMobile = window.cf.mobileCheck()
if (!isMobile) {
}

// var tabElementList = [].slice.call(document.querySelectorAll('.scrollDisplay [data-bs-toggle="tab"]'));
// tabElementList.forEach(function (tabToggleEl) {
//     var tab = new bootstrap.Tab(tabToggleEl);
//     tabToggleEl.addEventListener('click', function (event) {

//         setTimeout(function() {
//             console.log("testing2");
//             window.location.href = tabToggleEl.getAttribute("href");
//         },300)
//     });
//     tabToggleEl.addEventListener('mouseenter', function () {
//         tab.show();
//     });
//     tabToggleEl.offsetParent.addEventListener('mouseleave', function () {
//         tab.hide();
//     });
// });

console.log('modalLinks')
document.addEventListener('DOMContentLoaded', function () {
  // Find all links with href containing '#hasmodal_'
  const modalLinks = document.querySelectorAll('a[href*="#hasmodal_"]')

  modalLinks.forEach((link) => {
    // Extract the popup name from href
    const href = link.getAttribute('href')

    // Add the required attributes
    link.setAttribute('data-bs-toggle', 'modal')
    link.setAttribute('data-bs-target', href)
    link.setAttribute('gtm-interact', 'below_fold_click')
    link.setAttribute('target', '_self')
  })
})

// Lazy load form content (HubSpot embeds etc.) held in a <template> until needed.
// Hydration is idempotent: whichever trigger gets there first wins.
function hydrateLazyContent(container: Element) {
  if (container.classList.contains('js-lazyloaded')) {
    return
  }

  // Find the template element inside the container
  const template = container.querySelector('template')
  if (!template) {
    return
  }
  const content = template.innerHTML

  // Parse the content to handle scripts properly
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  const scripts = doc.querySelectorAll('script')

  // Insert non-script content first
  const fragment = document.createDocumentFragment()
  Array.from(doc.body.childNodes).forEach((node) => {
    if ((node as Element).tagName !== 'SCRIPT') {
      fragment.appendChild(node.cloneNode(true))
    }
  })
  container.appendChild(fragment)

  // Execute scripts manually
  scripts.forEach((oldScript) => {
    const newScript = document.createElement('script')
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value)
    })
    newScript.textContent = oldScript.textContent
    container.appendChild(newScript)
  })

  // Remove the container element (which includes the template)
  template.remove()
  container.classList.add('js-lazyloaded')
}

// Lazy load form content using Intersection Observer API
document.addEventListener('DOMContentLoaded', function () {
  const lazyLoadElements = document.querySelectorAll('.js-lazyload-inner-content')

  if (lazyLoadElements && lazyLoadElements.length === 0) {
    return
  }

  // Create Intersection Observer
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          hydrateLazyContent(entry.target)

          // Stop observing this element
          observer.unobserve(entry.target)
        }
      })
    },
    {
      // Trigger when element is 50% visible
      rootMargin: '50px',
      threshold: 0.5
    }
  )

  // Observe all lazy load elements
  lazyLoadElements.forEach((element) => {
    observer.observe(element)
  })
})

// A modal is display:none until it opens, so its placeholders can never intersect
// beforehand — and once open, a stacked mobile layout can leave the form column
// below the fold, where the 1px placeholder gives nothing to scroll towards. Hydrate
// on open instead. show.bs.modal bubbles, so one delegated listener covers every popup.
document.addEventListener('show.bs.modal', (event) => {
  const modal = event.target as Element | null
  modal?.querySelectorAll('.js-lazyload-inner-content').forEach(hydrateLazyContent)
})
